import { Injectable, Injector } from '@angular/core';
import { BaseReportService } from '../../shared/_utils/services/base-report-service';
import { LazyLoadEvent } from 'primeng/api';
import { HttpParams } from '@angular/common/http';
import { Vars } from '../model/vars';
import { Observable } from 'rxjs/Observable';
import { map , tap} from 'rxjs/operators';
import { catchError  } from 'rxjs/operators'; 
import { TimesheetDTO } from '../model/timesheet';
import { ParamsTimesheet } from '../model/params-timesheet'; 

@Injectable()
export class TimesheetService extends BaseReportService<TimesheetDTO> {

  public uri = '/api/timesheet/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance ReportDeductionsByEmployeeType');
  }

  buildSentence(entity?: TimesheetDTO, event?: LazyLoadEvent): HttpParams {
    return null;
  }

  searchToViewTable(   params : ParamsTimesheet
    ): Observable<any> { 
        this.spinnerService.showAll();
        const url = `${this.rutaServidor}${this.uri}search`;
        return this.httpClient.post<any>(url, params )
        .pipe(
          tap(response => {           
            if (response.numberOfElements > 0) {
              response.content.forEach((value) => {
                // debugger;
                this.convertToDate(value);
              })
            }
            return response;
          },
           error =>{ 
             this.spinnerService.hideAll();
           },
           ()=>{ 
            this.spinnerService.hideAll();
           }
          ), 
          catchError((err) => {
              this.spinnerService.hideAll();
              this.notificationService.serverErrorMessage(err); 
              return new Observable<Blob>();
          })
       );
  } 

   
  updateAttendanceBody( timesheet: TimesheetDTO): Observable<any> {
    this.spinnerService.showAll();
   const url = `${this.rutaServidor}${this.uri}updateAttendanceBody`; 
   //console.log("buscando ...");
   //const uploadData = new FormData();
   //uploadData.append('timesheet', JSON.stringify(timesheet)); 
  

   this.spinnerService.showAll();
   return this.httpClient.post<any>(url, timesheet )
   .pipe(
     tap(response => { 
       return response;
     },
      error =>{ 
      },
      ()=>{ 
       this.spinnerService.hideAll();
      }
     ), 
     catchError((err) => { 
         this.spinnerService.hideAll();
         //console.log(err);
         this.notificationService.serverErrorMessage(err);
         //if(err.status==404)
         //this.notificationService.smallBoxWarning("Ventana de Alerta!",resp);  
         return new Observable<Blob>();
     })
    );
  } 


  getDateRange( params: ParamsTimesheet): Observable<any> {
    this.spinnerService.showAll();
   const url = `${this.rutaServidor}${this.uri}getDateRange`; 
   this.spinnerService.showAll();
   return this.httpClient.post<any>(url, params )
   .pipe(
     tap(response => { 
      if (response.numberOfElements > 0) {
        response.content.forEach((value) => {
          // debugger;
          this.convertToDate(value);
        })
      }
       return response;
     },
      error =>{ 
      },
      ()=>{ 
       this.spinnerService.hideAll();
      }
     ), 
     catchError((err) => { 
         this.spinnerService.hideAll();
         //console.log(err);
         this.notificationService.serverErrorMessage(err);
         //if(err.status==404)
         //this.notificationService.smallBoxWarning("Ventana de Alerta!",resp);  
         return new Observable<Blob>();
     })
    );
  }  

  sendSubmitTimesheet(params: ParamsTimesheet): Observable<any> {
    this.spinnerService.showAll();
   const url = `${this.rutaServidor}${this.uri}sendSubmitTimesheet`; 
   this.spinnerService.showAll();
   return this.httpClient.post<any>(url, params )
   .pipe(
     tap(response => { 
       return response;
     },
      error =>{ 
      },
      ()=>{ 
       this.spinnerService.hideAll();
      }
     ), 
     catchError((err) => { 
         this.spinnerService.hideAll();
         //console.log(err);
         this.notificationService.serverErrorMessage(err);
         //if(err.status==404)
         //this.notificationService.smallBoxWarning("Ventana de Alerta!",resp);  
         return new Observable<Blob>();
     })
    );
  } 


  getBillingTimeHead( params: ParamsTimesheet): Observable<any> {
    this.spinnerService.showAll();
   const url = `${this.rutaServidor}${this.uri}getBillingTimeHead`; 
   this.spinnerService.showAll();
   return this.httpClient.post<any>(url, params )
   .pipe(
     tap(response => { 
      if (response) {
        response =    this.convertToDate(response);
        }
       return response;
     },
      error =>{ 
      },
      ()=>{ 
       this.spinnerService.hideAll();
      }
     ), 
     catchError((err) => { 
         this.spinnerService.hideAll();
         //console.log(err);
         this.notificationService.serverErrorMessage(err);
         //if(err.status==404)
         //this.notificationService.smallBoxWarning("Ventana de Alerta!",resp);  
         return new Observable<Blob>();
     })
    );
  }  

  sendSubmitApproval(params: ParamsTimesheet): Observable<any> {
    this.spinnerService.showAll();
   const url = `${this.rutaServidor}${this.uri}sendSubmitApproval`; 
   this.spinnerService.showAll();
   return this.httpClient.post<any>(url, params )
   .pipe(
     tap(response => { 
       return response;
     },
      error =>{ 
      },
      ()=>{ 
       this.spinnerService.hideAll();
      }
     ), 
     catchError((err) => { 
         this.spinnerService.hideAll();
         //console.log(err);
         this.notificationService.serverErrorMessage(err);
         //if(err.status==404)
         //this.notificationService.smallBoxWarning("Ventana de Alerta!",resp);  
         return new Observable<Blob>();
     })
    );
  } 


  getHoursWorked( params: ParamsTimesheet): Observable<any> {
    this.spinnerService.showAll();
   const url = `${this.rutaServidor}${this.uri}getHoursWorked`; 
   this.spinnerService.showAll();
   return this.httpClient.post<any>(url, params )
   .pipe(
     tap(response => { 
      if (response.numberOfElements > 0) {
        response.content.forEach((value) => {
          // debugger;
          this.convertToDate(value);
        })
      }
       return response;
     },
      error =>{ 
      },
      ()=>{ 
       this.spinnerService.hideAll();
      }
     ), 
     catchError((err) => { 
         this.spinnerService.hideAll();
         //console.log(err);
         this.notificationService.serverErrorMessage(err);
         //if(err.status==404)
         //this.notificationService.smallBoxWarning("Ventana de Alerta!",resp);  
         return new Observable<Blob>();
     })
    );
  }  
}



// WEBPACK FOOTER //
// ./src/app/core/services/timesheet.service.ts